<template>
  <router-view/>
</template>

<script>
export default {
	name: 'App',
}
</script>

<style>
[v-cloak] {display: none!important; }
</style>



// WEBPACK FOOTER //
// src/App.vue